// ── Bangla → ASCII transliteration (keeps slugs URL-safe) ─────────────────
const BN_TO_EN = {
    'অ': 'o',  'আ': 'a',  'ই': 'i',  'ঈ': 'i',  'উ': 'u',  'ঊ': 'u',
    'ঋ': 'ri', 'এ': 'e',  'ঐ': 'oi', 'ও': 'o',  'ঔ': 'ou',
    'ক': 'k',  'খ': 'kh', 'গ': 'g',  'ঘ': 'gh', 'ঙ': 'ng',
    'চ': 'ch', 'ছ': 'chh','জ': 'j',  'ঝ': 'jh', 'ঞ': 'n',
    'ট': 't',  'ঠ': 'th', 'ড': 'd',  'ঢ': 'dh', 'ণ': 'n',
    'ত': 't',  'থ': 'th', 'দ': 'd',  'ধ': 'dh', 'ন': 'n',
    'প': 'p',  'ফ': 'ph', 'ব': 'b',  'ভ': 'bh', 'ম': 'm',
    'য': 'j',  'র': 'r',  'ল': 'l',
    'শ': 'sh', 'ষ': 'sh', 'স': 's',  'হ': 'h',
    'ড়': 'r', 'ঢ়': 'rh','য়': 'y',
    'া': 'a',  'ি': 'i',  'ী': 'i',  'ু': 'u',  'ূ': 'u',
    'ৃ': 'ri', 'ে': 'e',  'ৈ': 'oi', 'ো': 'o',  'ৌ': 'ou',
    '্': '',   'ং': 'ng', 'ঃ': 'h',  'ঁ': 'n',
    '০': '0',  '১': '1',  '২': '2',  '৩': '3',  '৪': '4',
    '৫': '5',  '৬': '6',  '৭': '7',  '৮': '8',  '৯': '9',
};

export const transliterateBangla = (text) => String(text || '')
    .normalize('NFC')
    .replace(/[‌‍]/g, '')
    .split('').map(c => BN_TO_EN[c] !== undefined ? BN_TO_EN[c] : c).join('');

export const slugify = (text) => transliterateBangla(text)
    .toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '');
